export default __webpack_public_path__ + "static/DashlabsAI-497ae110d032b7a5bc5f6d9f5e65a943.png";